import { Chip } from '@mui/material';
import React from 'react';
import { IAuditEvent } from 'types/api';
import { isAuditEventFailed } from 'utils/auditUtils';

interface IAuditEventChipsProps {
	event: IAuditEvent;
}

export const AuditStatusChip: React.FC<IAuditEventChipsProps> = ({ event }) => {
	const failed = isAuditEventFailed(event);

	return (
		<Chip
			size="small"
			variant="outlined"
			color={failed ? 'error' : 'success'}
			data-testid="audit-status-chip"
			label={intl.tr(failed ? 'audit.status.failure' : 'audit.status.success')}
		/>
	);
};

export const AuditTestChip: React.FC<IAuditEventChipsProps> = ({ event }) =>
	event.ssoTest ? (
		<Chip
			size="small"
			variant="outlined"
			data-testid="audit-test-chip"
			label={intl.tr('audit.event.test')}
		/>
	) : null;
